// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"PageTitleWithImage_imageContainer__Mv_55","header":"PageTitleWithImage_header__1pkwI"};